/** @format */
import React from 'react';
import { Tabs } from 'antd';

export default function CustomTabs(props) {
	return (
		<>
			<Tabs {...props} />
		</>
	);
}

CustomTabs.TabPane = Tabs.TabPane;

